import * as UserApi from '@/api/user'
import authority from '@/utils/authority'

const state = {
  user: authority.get()
}

const mutations = {
  SET_USER(state, payload = {}) {
    Object.assign(state, payload)
  }
}

const actions = {
  async login({ commit }, data) {
    const user = await UserApi.login(data)
    commit('SET_USER', { user })
  },
  async logout({ commit }) {
    await UserApi.logout()
    commit('SET_USER', {
      user: {}
    })
    authority.clear()
  }
}

export default {
  state,
  mutations,
  actions
}
